<template>
  <el-row :gutter="30">

    <el-col :span="12" :xs="24">

      <el-tabs v-model="regStatusFilter" @tab-click="selectedAccess = null">
        <el-tab-pane name="none" :label="$t('regStatus.none')"/>
        <el-tab-pane name="pending" :label="$t('regStatus.pending')"/>
        <el-tab-pane name="active" :label="$t('regStatus.active')"/>
        <el-tab-pane name="disabled" :label="$t('regStatus.disabled')"/>
        <el-tab-pane name="inprogress" :label="$t('regStatus.inprogress')"/>
      </el-tabs>

      <data-table
        :model="visibleAccessHolders"
        :columns="extendedColumns"
        :operations="operations"
        single-select
        @row-click="accessHolderSelected" />

    </el-col>

    <el-col :span="12" :xs="24">
      <access-form v-if="!!selectedAccess" :access="selectedAccess" @submit="onSubmit" :disabled=" regStatusFilter === 'inprogress' " />
    </el-col>

  </el-row>
</template>

<script>
import api from 'service/api'
import AccessForm from './AccessForm'
import { post } from 'providers/http'

export default {
  name: 'single-access',
  props: {
    accessHolders: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    mobileId: {
      type: String
    },
    switchId: {
      type: String
    },
    unprocessedAccesses: {
      type: Array
    }
  },
  data () {
    return {
      selectedAccess: null,
      regStatusFilter: 'none'
    }
  },
  computed: {
    visibleAccessHolders () {
      if (this.regStatusFilter === 'inprogress') {
        return this.unprocessedAccesses
      }

      return this.accessHolders.filter(a => {
        if (this.regStatusFilter === 'none' && !a.access) {
          return true
        }

        return a.access && (a.access.registration_status === this.regStatusFilter)
      })
    },
    operations () {
      if (['none', 'inprogress'].includes(this.regStatusFilter)) return []

      return [
        {
          label: 'activate-scheduled',
          type: 'success',
          method: ({ access }) => this.activateAccess(access, true),
          precondition: s => s.access && s.access.registration_status !== 'active' && s.access.registration_status !== 'none'
        },
        {
          label: 'activate',
          type: 'success',
          method: ({ access }) => this.activateAccess(access, false),
          precondition: s => s.access && s.access.registration_status !== 'active' && s.access.registration_status !== 'none'
        },
        {
          label: 'disable-scheduled',
          type: 'warning',
          method: ({ access }) => this.disableAccess(access, true),
          precondition: s => s.access && s.access.registration_status === 'active'
        },
        {
          label: 'disable',
          type: 'warning',
          method: ({ access }) => this.disableAccess(access, false),
          precondition: s => s.access && s.access.registration_status === 'active'
        },
        {
          label: 'delete-scheduled',
          type: 'danger',
          method: ({ access }) => this.deleteAccess(access, true),
          precondition: s => s.access && s.access.registration_status !== 'none'
        },
        {
          label: 'delete',
          type: 'danger',
          method: ({ access }) => this.deleteAccess(access, false),
          precondition: s => s.access && s.access.registration_status !== 'none'
        }
      ]
    },
    extendedColumns () {
      if (this.regStatusFilter === 'inprogress') {
        return [...this.columns, '[T]access-registration-status']
      }

      return this.columns
    }
  },
  methods: {
    accessHolderSelected (accessHolder) {
      // Overwrite the properties of default access with the accessHolder's access values
      const access = Object.assign({}, accessHolder.access || {})

      access.switch_id = this.switchId || accessHolder.id
      access.mobile_id = this.mobileId || accessHolder.id

      this.selectedAccess = access
    },
    async onSubmit (formModel, scheduled) {
      try {
        await post(`api/v1/mobile-accesses/${formModel.id}`, formModel)

        this.showSuccess('access-saved')

        this.selectedAccess = null
      }
      catch (err) {
        console.error(err)
      }
    }
  },
  components: { AccessForm },
  mixins: [ api ]
}
</script>

<style>
  tr { cursor: pointer; cursor: hand; }
</style>



// WEBPACK FOOTER //
// SingleAccess.vue?4abf0047